import { useState } from "react";
import { Box, HStack, Image, Text, useMediaQuery } from "native-base";
import { COLORS } from "../../utils/colors";
import "./style.css";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import ContainerCards from "../cards";
import { approvedIconSvg } from "../../utils/svg";
import CustomButton from "../button";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import AttachmentsCards from "../../containers/attachmentCards";
import AccordionDetail from "../accordion";
import config from "../../utils/config";

const RadioButtons = ({
  options = [],
  selectedOption = "",
  handleOptionChange = () => {},
}) => {
  const sortedOptions = [...options].sort((a, b) => {
    if (a.status === "active" && b.status !== "active") return -1;
    if (a.status !== "active" && b.status === "active") return 1;
    return 0;
  });
  const [isOpen, setIsOpen] = useState(false);

  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const contents = () => {
    let index = 0;
    return sortedOptions.map((item) => {
      if (item.status === "inactive") {
        index++;
        return (
          <>
            <ContainerCards
              padding={1}
              width="100%"
              maxW="100%"
              height="auto"
              borderRadius="10px"
              background={COLORS.AGENCY_CARD_COLOR}
              boxShadow="none"
              mb={3}
            >
              <HStack
                justifyContent={"space-between"}
                alignItems={"center"}
                pl={4}
                pr={0}
                w={"100%"}
              >
                <HStack
                  space={1.5}
                  key={item.value}
                  className="radio-btns"
                  w={"100%"}
                  pr={3}
                  alignItems={"center"}
                >
                  <Text
                    color={COLORS.PARTNERS_HEADING_COLOR}
                    fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                    pt="13px"
                    mb={2}
                    width={"100%"}
                  >
                    {index + ". "}
                    {item.text}
                  </Text>
                </HStack>
              </HStack>
              {Object.keys(item?.path).length > 0 && (
                <Box p={"10px"} width={"100%"}>
                  <AttachmentsCards
                    fileName={item.path.doc_type}
                    fileSize={item.path.file_size}
                    path={config.bucketPath + item.path?.file_name}
                    timeline={item.path.uploaded_time}
                    attachments={true}
                    translateY={"-8px"}
                    height="fit-content"
                    minW="300px"
                  />
                </Box>
              )}
            </ContainerCards>
          </>
        );
      }
    });
  };

  return (
    <div>
      {sortedOptions.map((item, ind) => {
        return (
          item.status !== "inactive" && (
            <>
              <ContainerCards
                padding={1}
                width="100%"
                maxW="100%"
                height="auto"
                borderRadius="10px"
                background={COLORS.AGENCY_CARD_COLOR}
                boxShadow="none"
              >
                <HStack
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  pl={4}
                  pr={0}
                  w={"100%"}
                >
                  <HStack
                    space={1.5}
                    key={item.value}
                    className="radio-btns"
                    w={
                      item.status !== "null"
                        ? MobileWindow
                          ? "60%"
                          : "65%"
                        : "100%"
                    }
                    pr={3}
                    alignItems={"center"}
                  >
                    {item.status === "null" && (
                      <input
                        type="radio"
                        value={item.value}
                        checked={selectedOption === item.value}
                        onChange={handleOptionChange}
                        className="radio-btns"
                      />
                    )}
                    {/* <Text
                    color={COLORS.PARTNERS_HEADING_COLOR}
                    fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                    pt="13px"
                    mb={2}
                  >
                    {ind + 1 + ". "}
                  </Text> */}
                    {item.status !== "inactive" && (
                      <Text
                        color={COLORS.PARTNERS_HEADING_COLOR}
                        fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                        fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                        pt="13px"
                        mb={2}
                        width={"100%"}
                      >
                        {ind + 1 + ". "}
                        {item.text}
                      </Text>
                    )}
                  </HStack>
                  {item.status === "active" && (
                    <Box justifyContent="center">
                      <CustomButton
                        pl={0}
                        text="Approved"
                        startIcon={approvedIconSvg}
                        width="fit-content"
                        height="auto"
                        bgColor="none"
                        textColor={COLORS.APPROVE_TEXT_COLOR}
                        fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                        fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                      />
                      {/* {item.status === "inactive" && (
                      <HStack alignItems={"center"} space={2} pr={2.5}>
                        <Image
                          source={{
                            uri: require("../../utils/quickLinkImages/reject_icon.png"),
                          }}
                          alt="image"
                          width={"22px"}
                          height={"22px"}
                        />
                        <Text
                          width="fit-content"
                          bgColor="none"
                          color={COLORS.REJECT_TEXT_COLOR}
                          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                        >
                          Rejected
                        </Text>
                      </HStack>
                    )} */}
                    </Box>
                  )}
                </HStack>
                {item.status !== "inactive" &&
                  Object.keys(item.path).length > 0 && (
                    <Box p={"10px"} width={"100%"}>
                      <AttachmentsCards
                        fileName={item.path.doc_type}
                        fileSize={item.path.file_size}
                        path={config.bucketPath + item.path?.file_name}
                        timeline={item.path.uploaded_time}
                        attachments={true}
                        translateY={"-24px"}
                        height="fit-content"
                        minW="300px"
                      />
                    </Box>
                  )}
              </ContainerCards>
              <Box mt={3}></Box>
              {/* <br></br> */}
            </>
          )
        );
      })}
      {sortedOptions?.[0]?.status !== "null" &&
        sortedOptions?.[0]?.status !== undefined && (
          <AccordionDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title="Rejected Agencies"
            content={contents()}
            type="agencies"
          />
        )}
    </div>
  );
};

export default RadioButtons;
